// src/services/userService.js
import axiosInstance from './axiosInstance';

const getUserAchievements = async (userId) => {
  try {
    const response = await axiosInstance.get(`/users/${userId}/achievements`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user achievements:", error);
    throw error;
  }
};

const getCurrentUser = async () => {
  const response = await axiosInstance.get('/auth/me');
  return response.data;
};

const getNotificationSettings = async () => {
  const response = await axiosInstance.get('/users/me/notification-settings');
  return response.data;
};

const updateNotificationSettings = async ({ enabled, leadHours }) => {
  const response = await axiosInstance.put('/users/me/notification-settings', { enabled, leadHours });
  return response.data;
};

export default {
  getUserAchievements,
  getCurrentUser,
  getNotificationSettings,
  updateNotificationSettings
};